import { emptyApi } from "./emptyApi";
import qs from "qs";
import { FSP_GROUP } from "types/Models/group";

export type TeamMember = {
  name: string;
  email: string;
  role: string;
  status: "ARCHIVED" | "JOINED" | "INVITED";
  uuid: string;
  service_team: string;
  chat_role: string;
};

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getTeamManagementMembers: build.query<
      TeamMember[],
      { searchTerm?: string | null; serviceTeamId?: string | null }
    >({
      query: ({ searchTerm, serviceTeamId }) => {
        let queryUrl = qs.stringify(
          {
            search_term: searchTerm,
            service_team_id: serviceTeamId,
          },
          { skipNulls: true, addQueryPrefix: true }
        );
        return {
          url: `/api/inkle/serviceteams/settings/${queryUrl}`,
        };
      },
      providesTags: ["CPATeamManagement"],
    }),

    inviteManageTeamMembers: build.mutation({
      query: ({
        payload,
      }: {
        payload: {
          first_name: string;
          last_name: string;
          email: string;
        };
      }) => {
        return {
          url: `/api/inkle/serviceteams/settings/`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["CPATeamManagement"],
    }),

    changeAdmin: build.mutation<
      TeamMember,
      {
        memberId: string;
        payload: {
          action: string;
          reassign_invite_id?: string;
        };
      }
    >({
      query: ({ memberId, payload }) => {
        return {
          url: `/api/inkle/serviceteams/team_member/${memberId}/`,
          method: "PUT",
          body: payload,
        };
      },
      invalidatesTags: ["CPATeamManagement"],
    }),

    getPracticeDetail: build.query<FSP_GROUP, { serviceTeamId: string }>({
      query: ({ serviceTeamId }) => {
        return {
          url: `/api/inkle/serviceteams/${serviceTeamId}/`,
        };
      },
      providesTags: ["PracticeTeamManagement"],
    }),

    getChatRoleList: build.query<{ role_name: string; uuid: string }[], void>({
      query: () => {
        return {
          url: `/api/inkle/serviceteams/profile_role/`,
        };
      },
    }),
    updateChatRole: build.mutation<
      Pick<TeamMember, "chat_role" | "uuid">,
      { memberId: string; payload: { chat_role: string } }
    >({
      query: ({ memberId, payload }) => {
        return {
          url: `/api/inkle/serviceteams/team_member/${memberId}/chat_role/`,
          method: "PUT",
          body: payload,
        };
      },
      invalidatesTags: ["CPATeamManagement"],
    }),
  }),
});

export const {
  useGetTeamManagementMembersQuery,
  useInviteManageTeamMembersMutation,
  useChangeAdminMutation,
  useGetPracticeDetailQuery,
  useGetChatRoleListQuery,
  useUpdateChatRoleMutation,
} = extendedApi;
